import * as React from 'react';

import styles from './styles.module.scss';

interface OwnProps {
	title: string;
	renderButtons: () => React.JSX.Element;
}

type Props = OwnProps;

const ResourceHeader: React.FC<Props> = (props) => {
	const { title, renderButtons } = props;

	return (
		<div className={styles['resource-header-container']}>
			<div className={styles['resource-header-title']}>
				{title}
			</div>
			<div className={styles['resource-btn-container']}>
				{renderButtons()}
			</div>
		</div>
	);
};

export default React.memo(ResourceHeader);
